module.exports = __webpack_public_path__ + "static/media/Sternchen klein.83b5d5cb.png";